import { Loading } from "components";
import { ReportParamsType } from "constants/types/common";
import { FC } from "react";
import { useCollectionReport } from "utils/hooks/request/useReport";
import CollectionReportTable from "./components/CollectionReportTable/CollectionReportTable";

interface CollectionReportTabProps {
  params: ReportParamsType;
}

const CollectionReportTab: FC<CollectionReportTabProps> = ({ params }) => {
  const { collectionReport, isLoading } = useCollectionReport(params);

  return (
    <Loading variant="overlay" visible={isLoading}>
      <CollectionReportTable data={collectionReport ?? []} />
    </Loading>
  );
};

export default CollectionReportTab;
